
export enum TipoImpactoCambio {
    UTILIZAR_NORMA_ACUMULACION = 'UTILIZAR_NORMA_ACUMULACION',
    VOLVER_CALCULAR_SALDO = 'VOLVER_CALCULAR_SALDO'
}